/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { GuidedViewMenuResult } from './GuidedViewMenuResult'
import {
  GuidedViewMenuResultFromJSON,
  GuidedViewMenuResultFromJSONTyped,
  GuidedViewMenuResultToJSON,
} from './GuidedViewMenuResult'

/**
 *
 * @export
 * @interface ExploreMenuResponseWrapper
 */
export interface ExploreMenuResponseWrapper {
  /**
   *
   * @type {GuidedViewMenuResult}
   * @memberof ExploreMenuResponseWrapper
   */
  readonly success?: GuidedViewMenuResult | null
  /**
   *
   * @type {string}
   * @memberof ExploreMenuResponseWrapper
   */
  error?: string | null
}

/**
 * Check if a given object implements the ExploreMenuResponseWrapper interface.
 */
export function instanceOfExploreMenuResponseWrapper(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function ExploreMenuResponseWrapperFromJSON(
  json: any,
): ExploreMenuResponseWrapper {
  return ExploreMenuResponseWrapperFromJSONTyped(json, false)
}

export function ExploreMenuResponseWrapperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExploreMenuResponseWrapper {
  if (json === undefined || json === null) {
    return json
  }
  return {
    success: !exists(json, 'success')
      ? undefined
      : GuidedViewMenuResultFromJSON(json['success']),
    error: !exists(json, 'error') ? undefined : json['error'],
  }
}

export function ExploreMenuResponseWrapperToJSON(
  value?: ExploreMenuResponseWrapper | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    error: value.error,
  }
}
